import React from 'react';
import { Base, Skeleton } from 'lib/cortiUI';
export const TrackersConfigModalContentLoader = () => {
    const cardsArray = [0, 1, 2];
    return (React.createElement(Base, { display: "grid", "justify-content": "space-between", gap: 3, width: "100%", "data-cy": "trackersConfigModalContentLoader" }, cardsArray.map((num) => (React.createElement(Base, { display: "flex", flexDirection: "row", justifyContent: "space-between", gap: 6, key: num },
        React.createElement(Skeleton, { variant: "text", width: "50%", height: 30 }),
        React.createElement(Skeleton, { variant: "circular", height: 30, width: 30 }))))));
};
